import script from "./BillingPeriodSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingPeriodSwitch.vue?vue&type=script&setup=true&lang=js"

import "./BillingPeriodSwitch.vue?vue&type=style&index=0&id=0c891520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c891520"]])

export default __exports__